export const environment = {
  production: true,
  apiUrl: 'https://api.nightweb.noveltytechnology.com/api/v2/web',
  notificationUrl: 'https://api.nightweb.noveltytechnology.com',
};
